// extracted by mini-css-extract-plugin
export var button = "buttonStyles-module--button--da280";
export var childrenContainer = "buttonStyles-module--childrenContainer--4eba8";
export var secondaryButton = "buttonStyles-module--secondaryButton--d6a86";
export var spinner = "buttonStyles-module--spinner--01e52";